import { Injector, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AssociationController } from 'src/features/common/association/association.controller';
import { ApiHelper } from 'cad/common/services/api/api-helper';
import { AssociationApi } from 'src/features/common/association/association-api';

@Injectable()
export class PortfolioSegmentLocationApi implements AssociationApi {
  private readonly endpoint: string = 'portfolio/segment/';

  static createAssociationApi(
    apiHelper: ApiHelper,
    associationController: AssociationController,
    injector: Injector,
  ): AssociationApi {
    return new PortfolioSegmentLocationApi(apiHelper);
  }

  constructor(
    private apiHelper: ApiHelper,
  ) {}

  public findAll = (code: number | string): Observable<any> => {
    return this.apiHelper.request(this.endpoint + code + '/locations');
  }
}
